import {PermissionList} from '../../permissions/permission-list';
import {
    ActionColumn,
    BaseController,
    ColumnSettings,
    ExpandedStart,
    NumberColumnSettings,
    SearchModel,
    TableSettings
} from '@yasc/yasc-material-components';
import {BookingReq, BookingRes} from '../../contracts/v0/fibu/booking.contract';
import {Injectable} from '@angular/core';
import {fibuHiddenDefaultColumns, fibuSplitColumns, fibuViewDefaultColumns} from '../../models/table-view-settings';
import {L10nTranslationService} from 'angular-l10n';
import {RestApiService} from '../../services/rest-api.service';
import {RuntimeCacheService} from '../../services/runtime-cache.service';
import {MatDialog} from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class FBookingController extends BaseController<BookingRes, BookingReq, BookingReq> {
    override onCopy(): void {
        throw new Error('Not implemented!');
    }

    override onEdit(val?: BookingReq | undefined): void {
        throw new Error("Method not implemented.");
    }

    override onCreate(val?: BookingReq | undefined): void {
        throw new Error("Method not implemented.");
    }

    override onBulkUpdate(val: BookingReq[]): void {
        throw new Error("Method not implemented.");
    }

    override toUpdateRequest(val: BookingRes): BookingReq {
        throw new Error("Method not implemented.");
    }

    override toCreateRequest(val: BookingRes): BookingReq {
        throw new Error("Method not implemented.");
    }

    override onCancel(): void {
        throw new Error("Method not implemented.");
    }

    override onSave(): void {
        throw new Error("Method not implemented.");
    }

    override onDelete(): void {
        throw new Error("Method not implemented.");
    }

    override onBulkPost(): void {
        throw new Error("Method not implemented.");
    }

    constructor(
        private translate: L10nTranslationService,
        private restApiService: RestApiService,
        private runtimeCache: RuntimeCacheService,
        runTime: RuntimeCacheService,
        matDialog: MatDialog,
    ) {
        super();
        // @ts-ignore
        this.dialog = matDialog
        this.runTimeCache = runTime
        this.yascDataSource.Settings = this.getTableSettings();
        this.yascDataSource.Settings.ColumnSettings = this.getColumnSettings();
        this.currentCreateItem = new BookingReq();
    }

    override getTableSettings(): TableSettings<BookingRes> {

        let buttons = [];
        if (this.runtimeCache.hasPermission( PermissionList.FibuBookingUpdate)) {
            buttons.push(ActionColumn.Edit);
        }
        if (this.runtimeCache.hasPermission( PermissionList.FibuBookingDelete)) {
            buttons.push(ActionColumn.Delete);
        }

        return new TableSettings<BookingRes>({
            yascShowColumnsMenu: true,
            yascStickyHeader: true,
            yascMultiSelect: true,
            yascInlineEditing: false,
            yascRowClick: false,
            yascActionColumns: buttons,
            yascStartExpanded: ExpandedStart.AllExpanded,
            yascLabel: this.translate.translate('navFibBatchBooking'),
        });
    }

    override getColumnSettings(): ColumnSettings<BookingRes>[] {
        return [
            ...fibuViewDefaultColumns(this.translate),
            ...fibuSplitColumns(this.translate),
            ...fibuHiddenDefaultColumns(this.translate),
            new NumberColumnSettings('total', {
                yascDisplayFn: (val: BookingRes) => `${val.total.toFixed(2)} â‚¬`,
                yascLabel: this.translate.translate('fibuAmount'),
                yascWidth: 1,
                yascIndex: 12,
            }),
        ];
    }

    override loadData() {
        this.restApiService.v0.fibu.booking.getBatchBookings().subscribe({
            next: (val) => this.yascDataSource.TableData = val.data
        })
    }

    override add(req?: BookingReq) {
        this.restApiService.v0.fibu.booking.add(req ?? this.currentCreateItem!).subscribe({
            next: (val) => {
                this.yascDataSource?.TableData.push(val);
                this.currentCreateItem = new BookingReq();
            },
        })
    }

    override update(req?: BookingReq) {
        const id = req?.id ?? this.currentCreateItem!.id;
        const dto = req ?? this.currentCreateItem!;

        this.restApiService.v0.fibu.booking.update(id, dto).subscribe({
            next: (val) => {
                const index = this.yascDataSource?.TableData.findIndex(e => e.id == id);
                if (index != -1)
                    this.yascDataSource.TableData[index] = val;
                this.currentCreateItem = new BookingReq();
            },
        });
    }

    removeBookings(ids: number[]) {
        this.restApiService.v0.fibu.booking.deleteList(ids).subscribe({
            next: () => {
                this.yascDataSource!.data = this.yascDataSource?.data.filter(e => !ids.includes(e.id!));
            }
        });
    }

    bookingYearChanged(year: number) {
        this.restApiService.v0.fibu.bookingYearChanged(year);
        this.loadData();
    }


    bookingMonthChanged(month: any) {
        this.restApiService.v0.fibu.bookingMonthChanged(month);
        this.loadData();
    }
}